export default {
  logging: 'Connexion en cours...',
  logCall: 'Journal des appels',
  editLog: 'Éditer le journal',
  select: 'Sélectionner une correspondance de registre',
  OnHold: 'En attente',
  Ringing: 'Sonnerie en cours',
  CallConnected: 'Appel établi',
  unknownUser: 'Utilisateur inconnu',
  unknownNumber: 'Anonyme',
  unavailable: 'Non disponible',
  viewDetails: 'Afficher les détails',
};
